// eslint-disable-next-line import/prefer-default-export
export const reactDataGridLicenseKey =
  'AppName=TotalETOApp,Company=TotalETO,ExpiryDate=2023-03-07,LicenseDeveloperCount=4,LicenseType=single_app,Ref=TotalETOLicenseRef,Z=345568666-7566902092053215784-217103076616372461548842234';
